import { useFormContext } from "react-hook-form";
import styles from "Styles/Inputs.module.css";

export default function CheckboxInput({
  IDRoot = "checkbox",
  index,
  value,
  label,
  handleCheck,
  checked = false,
  disabled = false,
}) {
  const { register } = useFormContext();
  const displayLabel = label || value;

  return (
    <>
      <input
        {...register("checkbox", {
          required: "error msg",
        })}
        id={`${IDRoot}-${index}`}
        type="checkbox"
        value={value}
        className={styles.inputElement}
        onChange={(e) => handleCheck(e)}
        checked={checked}
        disabled={disabled}
      />
      <label className={styles.inputLabel} htmlFor={`${IDRoot}-${index}`}>
        {displayLabel}
      </label>
    </>
  );
}
// { required: "Required field, please fill in" }
